import { useState, useEffect, useRef } from "react";

interface ScrollDirectionInformation {
  scrollDirection: "up" | "down";
  scrollDirectionForButton: "up" | "down";
}
export function useScrollDirection(): ScrollDirectionInformation {
  const [scrollDirection, setScrollDirection] = useState(null);
  const [scrollDirectionForButton, setScrollDirectionForButton] = useState(null);
  const timeoutRef = useRef(null); 

  useEffect(() => {
    let lastScrollY = window.scrollY;

    const updateScrollDirection = () => {
      const scrollY = window.scrollY;
      const direction = scrollY > lastScrollY ? "down" : "up";
      if (direction !== scrollDirection) {
        setScrollDirection(direction);
      }
      if (direction !== scrollDirectionForButton) {
        setScrollDirectionForButton(direction);
      }
      if (direction === "down") {
        clearTimeout(timeoutRef?.current);
        timeoutRef.current = setTimeout(() => {
          setScrollDirection("up");
        }, 2000);
      }
      lastScrollY = scrollY > 0 ? scrollY : 0;
    };
    window.addEventListener("scroll", updateScrollDirection);
    return () => {
      window.removeEventListener("scroll", updateScrollDirection);
    }
  }, [scrollDirection]);

  return { scrollDirection, scrollDirectionForButton };
}
